export const DIRECT_SHIPMENT_FILTER_KEYS = new Set([
  'ARCHIVED',
  'link_code',
  'has_comments',
  'unread_mentions',
]);
